import React, { useEffect, useState } from "react";
import { genericFetchData } from "../../../Services/Service";
import { getUserRole } from "../../../Storage/Datastore";
import { checkPermission, getUserRoles } from "../../../Utils/Permissions";

export default function useDoctor() {
  const [page, setPage] = useState(1);
  const [doctorData, setDoctorData] = useState([]);
  const [modal, setModal] = useState({ isOpen: false });
  const [flaggedItems, setflaggedItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [doctorType, setDoctorType] = useState([]);
  const [locations, setLocations] = useState({});
  const [departments, setDepartments] = useState({});
  const [platform, setPlatform] = useState([]);
  const [hospital, setHospital] = useState([]);
  const [filter, setFilter] = useState({
    departmentId: 0,
    platformId: 0,
    keyword: "",
    locationId: 0,
    centerId: 0,
    approved: "",
  });

  const getDoctorsFilterData = async () => {
    const postFilterData = {
      ...filter,
      pageNo: page,
      pageSize: 10,
    };
    const response = await genericFetchData(
      `/professional/filtered`,
      "POST",
      postFilterData
    );
    const responseData = await response.json();

    if (responseData) {
      const mappedData = responseData?.professionals?.map((val) => {
        const userRole = getUserRole();
        if (checkPermission("DB_LEADS_APROVAL")) {
          const approval = getUserRoles(userRole);
          return {
            id: val?.id,
            cellItem1: val?.name,
            cellItem2: val?.department,
            cellItem3: val?.departmentApproved.includes(approval),
            cellItem4: val?.status,
          };
        } else {
          return {
            id: val?.id,
            cellItem1: val?.name,
            cellItem2: val?.department,
            cellItem3: val?.approved,
            cellItem4: val?.status,
            cellItem5: val?.center,
          };
        }
      });
      let res = { count: responseData?.count, professionals: mappedData };
      setDoctorData(res);
    }
  };

  const getAllLocations = async () => {
    const response = await genericFetchData(`/locations/basic/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setLocations(responseData.locations);
    } else {
      console.log("=======error");
    }
  };

  const getAllHospital = async () => {
    const response = await genericFetchData(`/center/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setHospital(responseData.centers);
    } else {
      console.log("======error");
    }
  };

  const getAllDepartment = async () => {
    const response = await genericFetchData(`/departments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setDepartments(responseData.departments);
    } else {
      console.log("=======error");
    }
  };

  const getAllPlatform = async () => {
    const response = await genericFetchData(`/data/platform/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setPlatform(responseData.platforms);
      console.log(responseData.platforms, "+++h");
    } else {
      console.log("=======error");
    }
  };

  // const handleSelectedLocation = (e, value) => {
  //   setLocationId(value?.id);
  //   getDoctorsFilterData(value?.id, departmentsId, onchangeValue);
  // };
  // const handleSelectedDepartment = (e, value) => {
  //   setDepartmentsId(value?.id);
  //   getDoctorsFilterData(locationId, value?.id, onchangeValue);
  // };
  // const onChagevalue = (e) => {
  //   setOnchangeValue(e.target.value);
  //   getDoctorsFilterData(locationId, departmentsId, e.target.value);
  // };
  useEffect(() => {
    getDoctorsFilterData();
    getAllLocations();
    getAllDepartment();
    getAllPlatform();
    getAllHospital();
  }, [page, filter]);

  const handleCheckboxChange = (checked, index) => {
    let approvedData = {};
    const userRole = getUserRole();
    if (checkPermission("DB_LEADS_APROVAL")) {
      const approv = getUserRoles(userRole);
      approvedData = {
        departmentApproved: { [approv]: checked },
        doctorId: index,
        doctorType: doctorType,
      };
      saveDoctorUpdate(approvedData);
    } else {
      approvedData = { approved: checked, doctorId: index };
      saveDoctorStatus(approvedData);
    }
    const approvedItem = doctorData?.professionals?.map((item) =>
      item.id === index ? { ...item, cellItem3: checked } : item
    );
    setCheckedItems(approvedItem);
  };

  const handleApprovePopup = (event, index) => {
    approveData.checked = event.target.checked;
    approveData.index = index;
    setModal({ isOpen: true, data: approveData });
  };

  const approveData = {
    headText: "",
    source: "Are you sure want to Approve?",
    type: "APPROVE",
    handleApprove: handleCheckboxChange,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const handleStausChange = (checked, index, reason) => {
    const approvedData = {
      status: checked ? "FLAGGED" : "GOOD",
      doctorId: index,
      reason: reason,
    };
    const approvedItem = doctorData?.professionals?.map((item) =>
      item.id === index ? { ...item, cellItem4: checked } : item
    );
    setflaggedItems(approvedItem);
    saveDoctorStatus(approvedData);
  };

  const handleStatusPopup = (event, index) => {
    statusData.checked = event.target.checked;
    statusData.index = index;
    setModal({ isOpen: true, data: statusData });
  };

  const statusData = {
    headText: "Add Flagged Reason",
    source: "Are you sure want to Approve?",
    type: "FLAG",
    handleApprove: handleStausChange,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "Cancel" },
      { id: 2, buttonName: "Add" },
    ],
  };

  const deleteTableCell = (cellId) => {
    const postData = {
      active: false,
      doctorId: cellId,
    };
    saveDoctorStatus(postData);
  };

  const handleDelete = (cellId) => {
    deleteBoxData.deleteId = cellId;
    setModal({ isOpen: true, data: deleteBoxData });
  };

  const deleteBoxData = {
    headText: "",
    source: "Are you sure want to delete?",
    type: "DELETE",
    deleteData: deleteTableCell,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const saveDoctorStatus = async (postData) => {
    const response = await genericFetchData(
      `/professional/status/save`,
      "POST",
      postData
    );
    const status = response.status;
    if (status === 200) {
      getDoctorsFilterData();
    } else if (status === 400) {
      const responseData = await response.json();
      const errorMessage = responseData.errorMessage;
      alert(errorMessage);
    }
  };
  const saveDoctorUpdate = async (postData) => {
    const response = await genericFetchData(
      `/professional/status/update`,
      "POST",
      postData
    );
    const status = response.status;
    if (status === 200) {
      getDoctorsFilterData();
    }
  };

  return {
    doctorData,
    page,
    locations,
    setPage,
    handleApprovePopup,
    handleStatusPopup,
    modal,
    setModal,
    checkedItems,
    setCheckedItems,
    flaggedItems,
    handleDelete,
    departments,
    setFilter,
    platform,
    hospital,
    setDoctorType,
    doctorType,
  };
}
